import {connect} from 'react-redux';
import {Button, Button as ButtonAntD, Card, Divider, Flex, message, Table, Tag, Typography, Row, Col} from 'antd';
import React, {useEffect, useState} from 'react';
import {API} from 'aws-amplify';
import ListTable from '../../../components/ListTable/ListTable';
import dayjs from 'dayjs';
import {CSVLink} from 'react-csv';
import {DownloadOutlined, ReloadOutlined, DeleteOutlined} from '@ant-design/icons';
import {useHistory} from 'react-router-dom';
import {DataStatus} from '../../../components/ComponentInfo/Status';
import {Checkbox, Input} from 'antd';


const Credits = ({app_state, getColumnSearchProps}) => {

  const history = useHistory();

  const [componentState, setComponentState] = useState({
    monoovaCredits: [],
    accountBalance: 0
  });

  const [componentInfo, setComponentInfos] = useState({
    fetchCreditsInfo: {
      status: DataStatus.Loading,
      callback: () => fetchMonoovaCredits()
    }
  });

  const [expandedRowKey, setExpandedRowKey] = useState(null);


  const fetchMonoovaBalance = async () => {
    API.get('bank-accounts', '/fetch/monoova-account/6279059756516800', {}).then(response => {
      setComponentState(prev => ({...prev, accountBalance: response.financials.actualBalance}));
    }).catch(err => {
      console.log(err);
    });
  };

  const updateReconciledFlag = async (event, record) => {
    const isChecked = event.target.checked;

    try {
      await API.post('commons', `/update/${record.id}`, {
        body: {
          context: 'monoova_credit',
          data: {
            reconciled: isChecked ? dayjs().utc().format('YYYY-MM-DD HH:mm:ss') : null,
            reconciledStaffID: isChecked ? app_state.current_staff.id : null
          }
        }
      });

      // Update the state to reflect the change
      setComponentState(prev => ({
        ...prev,
        monoovaCredits: prev.monoovaCredits.map(item =>
          item.id === record.id
            ? {
              ...item,
              reconciled: isChecked ? dayjs().format('YYYY-MM-DD HH:mm:ss') : null,
              reconciledStaffID: isChecked ? app_state.current_staff.id : null,
              nickname: isChecked ? app_state.current_staff.nickname : null
            }
            : item
        )
      }));
    } catch (err) {
      console.warn('Error: ', err);
    }
  };

  const markFundsReceived = async (record) => {
    try {
      await API.post('bank-accounts', `/funds-received/${record.id}`, {});
      message.success('Setting Funds Received');
      setComponentState(prev => ({
        ...prev,
        monoovaCredits: prev.monoovaCredits.map(item =>
          item.id === record.id
            ? {...item, transfer_status: 6}
            : item
        )
      }));
    } catch (err) {
      console.error('Error updating Transfer ID:', err);
      message.error('Failed to update Transfer ID');
    }
  };

  const depositToClientLedger = async (record) => {
    try {
      await API.post('bank-accounts', `/deposit-client/${record.id}`, {});
      message.success('Deposit to Client Ledger');
    } catch (err) {
      console.error('Error updating Transfer ID:', err);
      message.error('Failed to update Transfer ID');
    }
  };

  const depositToClientLedgerAgainstTransfer = async (record, transferID) => {
    try {
      await API.post('bank-accounts', `/deposit-client-transfer/${record.id}/${transferID}`, {});
      message.success('Deposit to Client Ledger');
    } catch (err) {
      console.error('Error updating Transfer ID:', err);
      message.error('Failed to update Transfer ID');
    }
  };

  const deleteClient = async (recordID) => {
    try {
      await API.post('commons', `/update/${recordID}`, {
        body: {
          context: 'monoova_credit',
          data: {
            clientID: null
          }
        }
      });
      message.success('Client ID updated successfully');
      setComponentState(prev => ({
        ...prev,
        monoovaCredits: prev.monoovaCredits.map(item =>
          item.id === recordID
            ? {...item, clientID: null}
            : item
        )
      }));
    } catch (err) {
      console.error('Error updating Client ID:', err);
      message.error('Failed to update Client ID');
    }
  };

  const deleteTransfer = async (recordID) => {
    try {
      await API.post('commons', `/update/${recordID}`, {
        body: {
          context: 'monoova_credit',
          data: {
            transferID: null
          }
        }
      });
      message.success('Transfer ID updated successfully');
      setComponentState(prev => ({
        ...prev,
        monoovaCredits: prev.monoovaCredits.map(item =>
          item.id === recordID
            ? {...item, transferID: null}
            : item
        )
      }));
    } catch (err) {
      console.error('Error updating Transfer ID:', err);
      message.error('Failed to update Transfer ID');
    }
  };

  useEffect(() => {
    fetchMonoovaBalance();
  }, []);


  const buildColumns = () => {
    return [
      {
        dataIndex: 'id',
        title: 'ID',
        sorter: (a, b) => a.id - b.id,
        defaultSortOrder: 'descend',
        render: (text) => text
      },
      {
        dataIndex: 'date',
        title: 'Date',
        sorter: {
          compare: (a, b) => {
            const dateA = new Date(a.datetime.split('/').reverse().join('/'));
            const dateB = new Date(b.datetime.split('/').reverse().join('/'));
            return dateA - dateB;
          }
        },
        ...getColumnSearchProps({
          dataIndex: 'datetime',
          filterInputType: 'DATE',
          render: (text, record) => <>{text}</>
        })
      },
      {
        dataIndex: 'time',
        title: 'Time',
        render: (text, record) => <>{text}</>
      },
      {
        dataIndex: 'transferID',
        title: 'Transfer ID',
        render: (text, record) => {
          const handleSaveTransferID = async (value) => {
            try {
              await API.post('commons', `/update/${record.id}`, {
                body: {
                  context: 'monoova_credit',
                  data: {
                    transferID: value
                  }
                }
              });
              message.success('Transfer ID updated successfully');
              setComponentState(prev => ({
                ...prev,
                monoovaCredits: prev.monoovaCredits.map(item =>
                  item.id === record.id
                    ? {...item, transferID: value}
                    : item
                )
              }));
            } catch (err) {
              console.error('Error updating Transfer ID:', err);
              message.error('Failed to update Transfer ID');
            }
          };

          let transferStatus = '';
          switch (record.transfer_status) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
              transferStatus = 'Awaiting Funds';
              break;
            case 6:
              transferStatus = 'Funds Received';
              break;
            case 7:
            case 8:
              transferStatus = 'Competed';
              break;
            case 9:
            case 10:
              transferStatus = 'Failed';
              break;
          }

          return text ? (<>
              <Typography.Link onClick={() => history.push(`/transfers/edit/${text}`)}>
                {text}
              </Typography.Link>
              &nbsp;&nbsp;<DeleteOutlined onClick={() => deleteTransfer(record.id)} style={{color: 'red'}}
                                          title={'Delete Transfer'} />
              <br />
              <small>{transferStatus}</small>
            </>
          ) : (
            <Input
              placeholder="Enter Transfer ID"
              maxLength={10}
              style={{width: 120}}
              onPressEnter={(e) => {
                if (e.target.value.trim()) {
                  handleSaveTransferID(e.target.value.trim());
                }
              }}
            />
          );
        }
      },
      {
        dataIndex: 'clientID',
        title: 'Client ID',
        sorter: (a, b) => a.clientID - b.clientID,
        render: (text, record) => {
          const handleSaveClientID = async (value) => {
            try {
              await API.post('commons', `/update/${record.id}`, {
                body: {
                  context: 'monoova_credit',
                  data: {
                    clientID: value
                  }
                }
              });
              message.success('Client ID updated successfully');
              setComponentState(prev => ({
                ...prev,
                monoovaCredits: prev.monoovaCredits.map(item =>
                  item.id === record.id
                    ? {...item, clientID: value}
                    : item
                )
              }));
            } catch (err) {
              console.error('Error updating Client ID:', err);
              message.error('Failed to update Client ID');
            }
          };

          return text ? (<>
              <Typography.Link onClick={() => history.push(`/clients/edit/${record.clientID}`)}>
                {text}
              </Typography.Link>
              &nbsp;&nbsp;<DeleteOutlined onClick={() => deleteClient(record.id)} style={{color: 'red'}}
                                          title={'Delete Client'} />
              <br />
              <small>{record.client_nickname}</small>
            </>
          ) : (
            <Input
              placeholder="Enter Client ID"
              maxLength={6}
              style={{width: 100}}
              onPressEnter={(e) => {
                if (e.target.value.trim()) {
                  handleSaveClientID(e.target.value.trim());
                }
              }}
            />);
        }
      },
      {
        dataIndex: 'transactionID',
        title: 'Transaction ID',
        render: (text) => text
      },
      {
        dataIndex: 'accountName',
        title: 'Account Name',
        render: (text, record) => <>
          <Typography.Link onClick={() => history.push(`clients/edit/${record.clientID}`)}>
            {text}
          </Typography.Link>
        </>
      },
      {
        dataIndex: 'description1',
        title: 'Description',
        render: (text, record) => <>
          <small>{record.remitterName}</small>
          <br />
          <small>{record.description1}</small>
          <br />
          <small>{record.description2}</small>
        </>
      },
      {
        dataIndex: 'accountNumber',
        title: 'Account Number',
        render: function(text, record) {
          if (record.accountNumber === '118295886') {
            return (
              <Typography>
                {record.bsb} {record.accountNumber}<br />
                <small>Jim Devenport</small>
              </Typography>
            );
          }
          if (record.accountNumber === '310352790') {
            return (
              <Typography>
                {record.bsb} {record.accountNumber}<br />
                <small>Ninja</small>
              </Typography>
            );
          }
          return (
            <Typography>
              {record.bsb} {record.accountNumber}
            </Typography>
          );
        }
      },
      {
        dataIndex: 'amount',
        title: 'Amount',
        render: (text) => {
          return new Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(text);
        }
      },
      {
        dataIndex: 'reconciled',
        title: 'Reconciled',
        render: (text, record) => <>
          <Checkbox checked={record.reconciled} onClick={event => updateReconciledFlag(event, record)}>
            {record.reconciled &&
              <small>
              <span>
                {dayjs(record.reconciled).format('DD/MM/YYYY')}<br />
                {dayjs(record.reconciled).format('HH:mm:ss')}<br />
                {record.nickname}
                </span>
              </small>
            }
          </Checkbox>
        </>
      }
    ];
  };


  const fetchMonoovaCredits = () => {
    const loading = message.loading('Fetching credits. Please wait..', 0);
    setExpandedRowKey([]);
    setComponentInfos(prev => ({
      ...prev,
      fetchCreditsInfo: {
        ...prev.fetchCreditsInfo,
        status: DataStatus.Loading
      }
    }));
    API.get('bank-accounts', '/fetch/monoova-credits', {})
      .then(response => {
        setComponentInfos(prev => ({
          ...prev,
          fetchCreditsInfo: {
            ...prev.fetchCreditsInfo,
            status: DataStatus.Loaded
          }
        }));
        setComponentState(prev => ({
          ...prev,
          monoovaCredits: response.map(item => ({
            ...item,
            date: dayjs(item.datetime).format('DD/MM/YYYY'),
            time: dayjs(item.datetime).format('HH:mm:ss')
          }))
        }));
      }).catch(err => {
      console.warn('Unable to fetch Credits. Please try again..');
      setComponentInfos(prev => ({
        ...prev,
        fetchCreditsInfo: {
          ...prev.fetchCreditsInfo,
          status: DataStatus.ErrorState
        }
      }));
    }).finally(() => loading());
  };

  const handleRowExpand = async (expanded, record) => {
    if (expanded) {
      try {
        if (record.clientID) {
          const client = await API.get('clients', `/get/id/${record.clientID}`, {});
          console.log('Client:', client);

          let holdingAccount = await API.get('holding_accounts', `/get/client-currency/${record.clientID}/1`);
          console.log('Holding Account:', holdingAccount);
          if (holdingAccount && holdingAccount.holding_account_list && holdingAccount.holding_account_list.length > 0) {
            holdingAccount = holdingAccount.holding_account_list[0];
          }

          setComponentState((prev) => ({
            ...prev,
            monoovaCredits: prev.monoovaCredits.map((item) =>
              item.id === record.id ? {...item, client, holdingAccount} : item
            )
          }));
        }

        if (record.transferID) {
          const transfer = await API.get('transfers', `/get/id/${record.transferID}`, {});
          console.log('Transfer:', transfer);
          setComponentState((prev) => ({
            ...prev,
            monoovaCredits: prev.monoovaCredits.map((item) =>
              item.id === record.id ? {...item, transfer: transfer ? transfer.fullList : {}} : item
            )
          }));
        }
      } catch (err) {
        console.error('Error fetching details:', err);
        message.error('Failed to fetch details');
      }
    }

    console.log('Row expanded:', record.id, 'Expanded:', expanded, 'Record:', record);
    setExpandedRowKey(expanded ? [record.id] : []);
  };

  useEffect(() => {
    fetchMonoovaCredits();
  }, [app_state.current_staff]);

  // console.log('Component State:', componentState);
  return <Card title={
    <Flex justify={'space-between'} align={'center'}>
      <h5>Monoova Credits</h5>
      <div>
        <Typography.Text>Account Balance: <Tag color={'success'} size={'large'}>{new Intl.NumberFormat('en-Au', {
          style: 'currency',
          currency: 'AUD'
        }).format(componentState.accountBalance)}</Tag></Typography.Text>
        <Button type={'primary'} size={'small'} danger onClick={fetchMonoovaCredits} icon={<ReloadOutlined />}
                style={{marginRight: 5}}>Refresh</Button>
        <CSVLink data={componentState.monoovaCredits} filename="monoova_credits.csv">
          <ButtonAntD type={'primary'} size={'small'} icon={<DownloadOutlined />}>
            Download CSV
          </ButtonAntD>
        </CSVLink>
      </div>
    </Flex>
  }>
    <Table
      loading={componentInfo.fetchCreditsInfo.status === DataStatus.Loading}
      columns={buildColumns()}
      dataSource={componentState.monoovaCredits}
      rowKey="id"
      expandable={{
        expandedRowRender: (record) => {
          console.log('Component State for Record:', record.id, componentState.monoovaCredits.filter(item => item.id === record.id));
          return (
            <Row gutter={16}>
              <Col span={8}>
                <p><strong>Account Details:</strong></p>
                <p>Account Name: {record.accountName}</p>
                <p>Account Number: {record.accountNumber}</p>
              </Col>
              {record.client &&
                <Col span={8}>
                  <p><strong>Client Details:</strong></p>
                  <p>Name: {record.client.nickname || 'N/A'}</p>
                  <p>Contact: {record.client.email} {record.client.telephone_home} {record.client.telephone_mobile}</p>
                  <Divider />
                  {record.holdingAccount &&
                    <>
                      <p style={{color: record.holdingAccount.balance < 0 ? 'red' : ''}}>
                        Current AUD Balance: {new Intl.NumberFormat('en-AU', {
                        style: 'currency',
                        currency: 'AUD'
                      }).format(record.holdingAccount.balance)}
                      </p>
                      {record.holdingAccount.balance > 0 && (record.holdingAccount.balance - record.amount) < 0 &&
                        <p>
                          Shortfall: {new Intl.NumberFormat('en-AU', {
                          style: 'currency',
                          currency: 'AUD'
                        }).format(record.holdingAccount.balance - record.amount)}
                        </p>
                      }
                    </>
                  }
                  <Button size={'small'}
                          disabled={[6, 7, 8, 9, 10].includes(record.transfer_status)}
                          onClick={() => depositToClientLedger(record)}
                  >
                    Deposit {new Intl.NumberFormat('en-AU', {
                    style: 'currency',
                    currency: 'AUD'
                  }).format(record.amount)} to Ledger
                  </Button>
                  <br />
                  {record.transfer &&
                    <>
                      <Button size={'small'}
                              disabled={[6, 7, 8, 9, 10].includes(record.transfer_status)}
                              onClick={() => depositToClientLedgerAgainstTransfer(record, record.transferID)}
                      >
                        Deposit {new Intl.NumberFormat('en-AU', {
                        style: 'currency',
                        currency: 'AUD'
                      }).format(record.amount)} to Ledger against TR {record.transferID}
                      </Button><br />
                      <em>This will deposit {new Intl.NumberFormat('en-AU', {
                        style: 'currency',
                        currency: 'AUD'
                      }).format(record.amount)} as part payment &amp; set debit holding</em>
                    </>
                  }
                </Col>
              }
              {record.transfer &&
                <Col span={8}>
                  <p><strong>Transfer Details:</strong></p>
                  <p>{record.transfer.nickname || 'N/A'}</p>
                  <p>AUD Amount: {new Intl.NumberFormat('en-AU', {
                    style: 'currency',
                    currency: 'AUD'
                  }).format(record.transfer.amount_from)}</p>
                  <Divider />
                  {(record.transfer.amount_from == record.amount) &&
                    <p style={{color: 'green'}}><strong>Deposit Amount Match</strong></p>

                  }
                  {!(record.transfer.amount_from == record.amount) &&
                    <p style={{color: 'red'}}><strong>Deposit Amount DOES NOT MATCH</strong></p>

                  }
                  <Button size={'small'}
                          disabled={[6, 7, 8, 9, 10].includes(record.transfer_status)}
                          onClick={() => markFundsReceived(record)}
                  >
                    Funds Received IN FULL
                  </Button>
                  <br />
                  <em>This will deposit {new Intl.NumberFormat('en-AU', {
                    style: 'currency',
                    currency: 'AUD'
                  }).format(record.transfer.amount_from)} as funds received today.</em>
                </Col>
              }
            </Row>
          );
        },
        onExpand: handleRowExpand
      }}
      expandedRowKeys={expandedRowKey || []} // Ensure expandedRowKeys is always an array
    />
  </Card>;
};


const mapStateToProps = state => ({
  app_state: state.app_state
});
const mapDispatchToProps = state => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ListTable(Credits));